(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inknorth-c3-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('in-wall-filter')) {
    class InWallFilter extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const chips = this.querySelector('[data-wall-chips]');
        if (!chips) return;
        chips.hidden = false;
        chips.addEventListener('click', (event) => this.onClick(event), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const chip = target.closest('[data-filter]');
        if (!chip) return;
        const filter = chip.getAttribute('data-filter') || 'all';
        for (const other of this.querySelectorAll('[data-filter]')) {
          other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
        }
        let shown = 0;
        for (const tile of this.querySelectorAll('.in-tile')) {
          const tags = (tile.getAttribute('data-tags') || '').split(' ');
          const show = filter === 'all' || tags.includes(filter);
          tile.hidden = !show;
          if (show) shown += 1;
        }
        const empty = this.querySelector('[data-wall-empty]');
        if (empty) empty.hidden = shown > 0;
      }
    }
    customElements.define('in-wall-filter', InWallFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inknorth-c3-group"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('in-size-grid')) {
    class InSizeGrid extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('input', () => this.update(), { signal: this.controller.signal });
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      update() {
        const output = this.querySelector('[data-size-total]');
        if (!output) return;
        let total = 0;
        for (const input of this.querySelectorAll('[data-size-qty]')) {
          total += Math.max(0, parseInt(input.value, 10) || 0);
        }
        output.textContent = String(total);
      }
    }
    customElements.define('in-size-grid', InSizeGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
